<template>
  <Can :ability="globalAdmin">
    <SidebarGroup :group="adminItems" />
  </Can>
</template>
<script setup lang="ts">
import type { NavGroup } from "./Group.vue";
const isDev = import.meta.dev;

const adminItems = computed<NavGroup>(() => ({
  label: {
    icon: "lucide:shield-check",
    title: "Global Admin",
  },
  items: [
    {
      to: "/admin/act-as-account",
      isActive: "equals",
      title: "Act As Account",
      icon: "lucide:eye",
    },
    {
      to: "/admin/users",
      isActive: "startsWith",
      title: "Manage Users",
      icon: "lucide:users",
    },
    {
      hidden: !isDev,
      to: "/admin/design-system",
      isActive: "equals",
      title: "Design System",
      icon: "lucide:palette",
    },
  ],
}));
</script>
